import Satellite from './Satellite'

export default Satellite
